import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import Cookies from 'js-cookie'
import ConvertToNewEmail from '@/components/ConvertToNewEmail.vue'
import SignupMainContainer from '@/components/signup/SignupMainContainer.vue'


export default {
  __name: 'ConfirmEmailAddress',
  setup(__props) {

const store = useStore()
const router = useRouter()

const isLoggedIn = computed(() => !!store.state.loggedInUser?.attributes || !!Cookies.get('auth_token'))

const goToLogin = () => {
  router.push('/login')
}

return (_ctx, _cache) => {
  return (isLoggedIn.value)
    ? (_openBlock(), _createBlock(ConvertToNewEmail, {
        key: 0,
        standalone: "",
        "dismiss-to-path": "/",
        mode: "suggest"
      }))
    : (_openBlock(), _createBlock(SignupMainContainer, {
        key: 1,
        title: "Confirm Your Email",
        "image-position": "left",
        "max-width": "md:max-w-xl",
        "hide-log-out": true
      }, {
        body: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createElementVNode("p", { class: "text-gray-800 text-center py-4" }, " To set up signing in with your email, please log in to your Bottle account below. After you've logged in, click the link in your email again to continue. ", -1)
        ]))]),
        footer: _withCtx(() => [
          _createElementVNode("div", { class: "flex justify-end w-full" }, [
            _createElementVNode("button", {
              type: "button",
              class: "inline-flex items-center border-gray-800 border-2 font-bold text-md hover:shadow-lg transition-all rounded-full px-6 py-3.5 leading-tight bg-yellow-200 text-gray-800",
              onClick: goToLogin
            }, [...(_cache[1] || (_cache[1] = [
              _createElementVNode("span", { class: "ml-auto transform -translate-y-px mr-4" }, "Log in", -1),
              _createElementVNode("span", { class: "mr-auto" }, [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "34",
                  height: "13",
                  viewBox: "0 0 34 13"
                }, [
                  _createElementVNode("path", {
                    d: "M3.11,6.82A20,20,0,0,1,1.2,6a.46.46,0,0,0-.67.15A2.32,2.32,0,0,0,0,7.25C0,7.64,0,7.84.3,8c.59.25,1.18.52,1.78.72",
                    transform: "translate(0 0)"
                  }),
                  _createElementVNode("path", {
                    d: "M1.83,8.58A23.56,23.56,0,0,0,7.36,10a36.41,36.41,0,0,0,8.79,0A53.55,53.55,0,0,0,29.69,6.72l.19-.07,0,0c-.33.4-.65.8-1,1.19-.72.87-1.45,1.73-2.16,2.61a1.75,1.75,0,0,0,0,2.28.68.68,0,0,0,.52.22.73.73,0,0,0,.5-.26c.67-.78,1.33-1.58,2-2.39l3.65-4.41A2.13,2.13,0,0,0,34,4.5,1.24,1.24,0,0,0,33.91,4a.87.87,0,0,0-.28-.36,1.55,1.55,0,0,0-.32-.2L26.59.11c-.65-.31-1.25.05-1.54.92a1.22,1.22,0,0,0,.4,1.5c.95.49,1.91,1,2.86,1.42l1.78.89-.19.08A55.6,55.6,0,0,1,17.44,8a36.08,36.08,0,0,1-8.87.12A21.78,21.78,0,0,1,2.82,6.7c-.3-.12-.73-.1-1-.25",
                    fill: "#000000",
                    transform: "translate(0 0)"
                  })
                ])
              ], -1)
            ]))])
          ])
        ]),
        _: 1
      }))
}
}

}